import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GapAnalysis from "./GapAnalysis";
import { changeStep, fetchResult } from "../../modules/results/actions";
import { changeLanguage } from "../../modules/preference/actions";

class GapAnalysisContainer extends React.Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    this.props.fetchResult(id);
  }
  render() {
    return <GapAnalysis {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    step: state.results.step,
    language: state.preference.language,
    groupedByCategory: state.results.groupedByCategory,
    result: state.results.result
      .sort((a, b) => b.difference - a.difference)
      .filter((item, index) => index < 4)
  };
}

const mapActionsToProps = {
  changeStep,
  fetchResult,
  changeLanguage
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(GapAnalysisContainer)
);



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/GapAnalysisContainer.js